export default {
      id: "star-usage",
      viewBox: "0 0 16 15",
      url: __webpack_public_path__ + "img/icons.svg#star",
      toString: function () {
        return this.url;
      }
    }